module.exports = __webpack_public_path__ + "img/avada-food-logo.8eea4cfb.png";